import React from 'react'
import { Pagination } from '@shopify/polaris'
import { ItemsPerPage } from 'Redux/genericReducers'

const AppointoPagination = ({ offset, list, onPrevious, onNext }) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingTop: 20,
        paddingBottom: 20,
      }}
    >
      <Pagination
        hasPrevious={offset > 0}
        onPrevious={onPrevious}
        hasNext={list.length === ItemsPerPage}
        onNext={onNext}
      />
    </div>
  )
}

export default AppointoPagination
